import { Component, ElementRef, inject, input, OnDestroy, OnInit, output } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { MenuItemDto } from '@core/services/api-clients';
import { fromEvent, Subscription } from 'rxjs';
import { MenuGroupItemsComponent } from '../menu-group-items/menu-group-items.component';

@Component({
  selector: 'app-menu-popup',
  templateUrl: './menu-popup.component.html',
  styleUrls: ['./menu-popup.component.scss'],
  imports: [MatDivider, MenuGroupItemsComponent],
})
export class MenuPopupComponent implements OnInit, OnDestroy {
  private ref = inject(ElementRef);

  readonly menuItems = input<MenuItemDto[]>(undefined);
  readonly groupName = input<string>('');
  readonly selectedMenuItemId = input<string>(undefined);

  readonly menuItemClick = output<MenuItemDto>();
  readonly menuItemAddedToFavorite = output<MenuItemDto>();
  readonly menuItemRemovedFromFavorite = output<MenuItemDto>();
  readonly isOver = output<any>();

  private subscriptions = new Subscription();

  constructor() {}

  ngOnInit(): void {
    const moveOut$ = fromEvent(this.ref.nativeElement, 'mouseout');
    const moveIn$ = fromEvent(this.ref.nativeElement, 'mouseover');

    this.subscriptions.add(
      moveOut$.subscribe(() => {
        this.isOver.emit(false);
      }),
    );
    this.subscriptions.add(
      moveIn$.subscribe(() => {
        this.isOver.emit(true);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onMenuItemClick(menuItem: MenuItemDto) {
    this.menuItemClick.emit(menuItem);
  }

  addMenuItemToFavorite(menuItem: MenuItemDto) {
    this.menuItemAddedToFavorite.emit(menuItem);
  }

  removeMenuItemFromFavorite(menuItem: MenuItemDto) {
    this.menuItemRemovedFromFavorite.emit(menuItem);
  }
}
